import { render, staticRenderFns } from "./ResourcesFrench.vue?vue&type=template&id=d601e1e4&"
import script from "./ResourcesFrench.vue?vue&type=script&lang=js&"
export * from "./ResourcesFrench.vue?vue&type=script&lang=js&"
import style0 from "./ResourcesFrench.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports